//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReportRemarkImportantCheckbox from './ReportRemarkImportantCheckbox.vue'

export default {
  components: {
    ReportRemarkImportantCheckbox
  },
  props: {
    remark: {
      type: Object,
      default () {
        return {}
      }
    },
    roleEmployee: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    reportRoles: {
      type: Object,
      default: function () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    onRemarkChanged: function (result) {
      if (result === true) {
        this.remark.active = true
      } else if (result === false) {
        this.remark.active = false
      }

      this.$emit('remark-changed')
    }
  }
}

